// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attachment-modal-dark-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* Dark translucent background */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1999; /* Below the main modal content */
}

.attachment-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);
  background-color: rgba(255, 255, 255, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000; /* Ensure it's on top of everything */
}

.attachment-modal-content-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 90vw;
  max-height: 90vh;
}

.attachment-modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.attachment-modal-close-btn {
  position: fixed;
  top: 15px;
  right: 10px;
  background-color: white;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2001; /* Above the media content */
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}

.attachment-modal-close-btn i {
  color: black;
  font-size: 20px;
}

.attachment-modal-actions {
  position: fixed;
  top: 80px; /* Below the close button */
  right: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 2001;
}

.attachment-modal-action-btn {
  background-color: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  transition: background-color 0.2s ease;
}

.attachment-modal-action-btn i {
  color: #333;
  font-size: 18px;
}

.attachment-modal-react-icon {
  width: 20px;
  height: 20px;
  filter: grayscale(100%);
  opacity: 0.8;
}

.attachment-modal-emoji-picker-container {
  position: fixed;
  top: 210px;
  right: 50px;
  z-index: 2002; /* Above the modal overlay */
}

.attachment-modal-action-btn:hover {
  background-color: white;
}

.attachment-modal-media-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative; /* For positioning reactions */
  max-width: 100%;
  max-height: calc(90vh - 100px); /* Reserve space for details below */
}

.attachment-modal-media {
  max-width: 90vw;
  max-height: calc(90vh - 100px);
  width: auto;
  height: auto;
  object-fit: contain;
}

.attachment-modal-text-content {
  max-width: 90%;
  max-height: 80vh;
  overflow: auto;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  padding: 24px;
  margin: 20px;
}

.attachment-modal-text-content pre {
  margin: 0;
  font-family: 'Courier New', monospace;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-wrap: break-word;
  color: #333;
}

.attachment-modal-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Align items to the left */
  text-align: left;
  margin-top: 16px;
  color: #333;
  width: 100%;
}

.attachment-modal-file-info {
  font-weight: bold;
  font-size: 16px;
  color: black;
}

.attachment-modal-view-btn {
  color: red;
  text-decoration: none;
}

.attachment-modal-view-btn:hover {
  opacity: 0.8;
}

.message-reactions.in-modal {
  position: absolute;
  bottom: 5px;
  left: -5px;
  z-index: 1;
}

.attachment-modal-fallback-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: #888;
  font-style: italic;
  font-size: 16px;
  width: 250px;
  height: 150px;
  border-radius: 8px;
  text-align: center;
}

.attachment-modal-loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  color: white;
  text-shadow: 0 1px 2px rgba(0,0,0,0.5);
}

.attachment-modal-loading-text {
  font-size: 16px;
  font-weight: 500;
}

/* Malware warning toast */
.attachment-modal-malware-toast {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10001;
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #2d2d2d;
  color: #fff;
  border-left: 4px solid #f0ad4e;
  border-radius: 6px;
  padding: 12px 16px;
  max-width: 480px;
  width: max-content;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.45);
  animation: toast-fade-in 0.25s ease;
}

@keyframes toast-fade-in {
  from { opacity: 0; transform: translateX(-50%) translateY(12px); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0); }
}

.attachment-modal-malware-toast-icon {
  color: #f0ad4e;
  font-size: 18px;
  flex-shrink: 0;
}

.attachment-modal-malware-toast-text {
  font-size: 13px;
  line-height: 1.4;
  flex: 1;
}

.attachment-modal-malware-toast-dismiss {
  background: none;
  border: none;
  color: #aaa;
  cursor: pointer;
  padding: 0 2px;
  font-size: 14px;
  flex-shrink: 0;
  line-height: 1;
}

.attachment-modal-malware-toast-dismiss:hover {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/Messages/AttachmentPreviewModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC,EAAE,gCAAgC;EACtE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,iCAAiC;AAClD;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,gDAAgD;EAChD,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,qCAAqC;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,aAAa,EAAE,4BAA4B;EAC3C,4EAA4E;AAC9E;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS,EAAE,2BAA2B;EACtC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4EAA4E;EAC5E,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,aAAa,EAAE,4BAA4B;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB,EAAE,8BAA8B;EAClD,eAAe;EACf,8BAA8B,EAAE,oCAAoC;AACtE;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,4BAA4B;EACrD,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE,4CAA4C,EAAE;EACjE,OAAO,UAAU,EAAE,yCAAyC,EAAE;AAChE;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".attachment-modal-dark-wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5); /* Dark translucent background */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1999; /* Below the main modal content */\n}\n\n.attachment-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  transition: 450ms cubic-bezier(0.23, 1, 0.32, 1);\n  background-color: rgba(255, 255, 255, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000; /* Ensure it's on top of everything */\n}\n\n.attachment-modal-content-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 90vw;\n  max-height: 90vh;\n}\n\n.attachment-modal-content {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.attachment-modal-close-btn {\n  position: fixed;\n  top: 15px;\n  right: 10px;\n  background-color: white;\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 2001; /* Above the media content */\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;\n}\n\n.attachment-modal-close-btn i {\n  color: black;\n  font-size: 20px;\n}\n\n.attachment-modal-actions {\n  position: fixed;\n  top: 80px; /* Below the close button */\n  right: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  z-index: 2001;\n}\n\n.attachment-modal-action-btn {\n  background-color: rgba(255, 255, 255, 0.9);\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;\n  transition: background-color 0.2s ease;\n}\n\n.attachment-modal-action-btn i {\n  color: #333;\n  font-size: 18px;\n}\n\n.attachment-modal-react-icon {\n  width: 20px;\n  height: 20px;\n  filter: grayscale(100%);\n  opacity: 0.8;\n}\n\n.attachment-modal-emoji-picker-container {\n  position: fixed;\n  top: 210px;\n  right: 50px;\n  z-index: 2002; /* Above the modal overlay */\n}\n\n.attachment-modal-action-btn:hover {\n  background-color: white;\n}\n\n.attachment-modal-media-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative; /* For positioning reactions */\n  max-width: 100%;\n  max-height: calc(90vh - 100px); /* Reserve space for details below */\n}\n\n.attachment-modal-media {\n  max-width: 90vw;\n  max-height: calc(90vh - 100px);\n  width: auto;\n  height: auto;\n  object-fit: contain;\n}\n\n.attachment-modal-text-content {\n  max-width: 90%;\n  max-height: 80vh;\n  overflow: auto;\n  background-color: rgba(255, 255, 255, 0.95);\n  border-radius: 8px;\n  padding: 24px;\n  margin: 20px;\n}\n\n.attachment-modal-text-content pre {\n  margin: 0;\n  font-family: 'Courier New', monospace;\n  font-size: 14px;\n  line-height: 1.6;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  color: #333;\n}\n\n.attachment-modal-details {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* Align items to the left */\n  text-align: left;\n  margin-top: 16px;\n  color: #333;\n  width: 100%;\n}\n\n.attachment-modal-file-info {\n  font-weight: bold;\n  font-size: 16px;\n  color: black;\n}\n\n.attachment-modal-view-btn {\n  color: red;\n  text-decoration: none;\n}\n\n.attachment-modal-view-btn:hover {\n  opacity: 0.8;\n}\n\n.message-reactions.in-modal {\n  position: absolute;\n  bottom: 5px;\n  left: -5px;\n  z-index: 1;\n}\n\n.attachment-modal-fallback-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: white;\n  color: #888;\n  font-style: italic;\n  font-size: 16px;\n  width: 250px;\n  height: 150px;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.attachment-modal-loading-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  color: white;\n  text-shadow: 0 1px 2px rgba(0,0,0,0.5);\n}\n\n.attachment-modal-loading-text {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n/* Malware warning toast */\n.attachment-modal-malware-toast {\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10001;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background-color: #2d2d2d;\n  color: #fff;\n  border-left: 4px solid #f0ad4e;\n  border-radius: 6px;\n  padding: 12px 16px;\n  max-width: 480px;\n  width: max-content;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.45);\n  animation: toast-fade-in 0.25s ease;\n}\n\n@keyframes toast-fade-in {\n  from { opacity: 0; transform: translateX(-50%) translateY(12px); }\n  to   { opacity: 1; transform: translateX(-50%) translateY(0); }\n}\n\n.attachment-modal-malware-toast-icon {\n  color: #f0ad4e;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.attachment-modal-malware-toast-text {\n  font-size: 13px;\n  line-height: 1.4;\n  flex: 1;\n}\n\n.attachment-modal-malware-toast-dismiss {\n  background: none;\n  border: none;\n  color: #aaa;\n  cursor: pointer;\n  padding: 0 2px;\n  font-size: 14px;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n.attachment-modal-malware-toast-dismiss:hover {\n  color: #fff;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
